/**
 * The app's react-query client. Query keys start with the feature name so a feature can
 * invalidate its own data: ["materials", "list", params], ["jobs", "detail", id].
 */
import { QueryClient } from "@tanstack/react-query";
import { isApiError } from "./client";

/** Client errors won't fix themselves on retry; network blips and 5xx get two more tries. */
function shouldRetry(failureCount: number, error: unknown): boolean {
  if (isApiError(error) && error.status >= 400 && error.status < 500) return false;
  return failureCount < 2;
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: shouldRetry,
        refetchOnWindowFocus: false,
      },
      mutations: { retry: false },
    },
  });
}

export const queryClient = createQueryClient();
